import { AxAssetStatus } from '@crimsontide/core/client/interfaces';
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;
let cachedAssetStatuses: AxAssetStatus[];

export const AxAssetStatusService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getAxAssetStatuses = async (useCache: boolean = true): Promise<AxAssetStatus[]> => {
    if (useCache && cachedAssetStatuses != null)
      return cachedAssetStatuses;

    if (dotNetObj) {
      cachedAssetStatuses = await dotNetObj.invokeMethodAsync<AxAssetStatus[]>('GetAxAssetStatusesAsync');
      return cachedAssetStatuses;
    } else {
      throw 'AxAsset Status DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getAxAssetStatuses,
  };
})();
